import Pacientes from '../components/Pacientes/Pacientes'

let routes = {
    path: '/pacientes',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/pacientes',
            name: 'Pacientes',
            component: Pacientes
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/pacientes.js